import { Component, OnInit } from "@angular/core";
import { ChartOptions, ChartType, ChartDataSets, Chart } from "chart.js";
import { SharedService } from "../../../shared/services/shared.service";
import { TokenService } from "../../../core/tokenManagement/token.service";
import { environment } from "../../../../environments/environment";
import { Notification } from "../../../core/helpers/notification";
import { ErrorHandlers } from "../../../core/helpers/errorhandlers";

@Component({
  selector: "app-dashaboard",
  templateUrl: "./dashaboard.component.html",
  styleUrls: ["./dashaboard.component.css"],
})
export class DashaboardComponent implements OnInit {
  constructor(
    private sharedserv: SharedService,
    private tokenservice: TokenService,
    private notservice: Notification,
    private err: ErrorHandlers
  ) {}
  datareq = new DataReq();
  days = 30;
  userLocalDetails;
  customLink: string;
  successfulValue = 0.0;
  successfulVolume = 0.0;
  settlementValue = 0.0;
  settlementVolume = 0.0;
  doughtData = [];
  doughlabel = [];

  ngOnInit() {
    this.datareq.maxTransactionDate = new Date().toISOString().substring(0, 10);
    this.userLocalDetails = this.tokenservice.getUserCred();
    // this.onDateChange(this.days);
    this.getUserDefaultLink();
  }

  onDateChange(e) {
    let searchDate = new Date().getTime() - 86400000 * e;
    this.datareq.minTransactionDate = new Date(searchDate)
      .toISOString()
      .substring(0, 10);
    // this.getDashboardData();
  }

  public barChartOptions: ChartOptions = {
    responsive: true,
    legend: { position: "bottom" },

    // We use these empty structures as placeholders for dynamic theming.
    scales: {
      xAxes: [
        {
          barPercentage: 0.6,
          type: "time",
          time: {
            unit: "day",
            displayFormats: {
              day: "MMM D",
            },
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
    plugins: {
      datalabels: {
        anchor: "end",
        align: "end",
      },
    },
  };
  barChartLabels = [];
  barData = [];
  barlabels = [];
  barChartType: ChartType = "bar";
  barChartLegend = true;

  barChartData: ChartDataSets[] = [
    {
      data: [],
      label: "Transaction Value",
    },
  ];

  bckcolor = [
    {
      backgroundColor: "#008000",
    },
  ];

  // doughnut
  Doughchart = [];

  configDoughChart() {
    this.doughlabel =
      this.doughlabel.length > 0 ? this.doughlabel : ["Cash", "Card", "Bank"];
    this.Doughchart = new Chart("canvas", {
      type: "doughnut",
      data: {
        labels: this.doughlabel,
        datasets: [
          {
            data: this.doughtData.length > 0 ? this.doughtData : [0, 0, 0],
            backgroundColor: ["#950007", "green", "#BE5504"],
          },
        ],
      },
      options: {
        legend: {
          display: true,
          position: "right",
        },
      },
    });
  }

  getDashboardData() {
    this.sharedserv.getDashBoardData("").subscribe(
      async (data) => {
        this.constructDoughData_Summary(await data["summary"]);
        this.constructBar_summary(await data["details"]);
        // this.separateSummaryTxnType(data["summary"].transactions);

        // let x = data["summary"].transactions[0];
        // let y = data["summary"].settlement[0];
        // this.successfulValue = x.successValueSum ? x.successValueSum : 0.0;
        // this.successfulVolume = x.successVolumeSum ? x.successVolumeSum : 0.0;
        // this.settlementValue = y.successValueSum ? y.successValueSum : 0.0;
        // this.settlementVolume = y.successVolumeSum ? y.successVolumeSum : 0.0;
      },
      (eror) => {
        this.configDoughChart();
      }
    );
  }

  constructDoughData_Summary(res) {
    this.doughtData = [];
    this.doughlabel = [];
    let arrHolder = res["paymentChannel"];
    for (let a = 0; a < arrHolder.length; a++) {
      this.doughtData.push(arrHolder[a].successValueSum);
      this.doughlabel.push(arrHolder[a].paymentChannel);
    }
    this.configDoughChart();
  }

  constructBar_summary(res) {
    this.barlabels = [];
    this.barData = [];
    let arrHolder = res["transactions"];
    for (let a = 0; a < arrHolder.length; a++) {
      this.barChartLabels.push(arrHolder[a].transactionDate.substring(0, 10));
      this.barData.push(arrHolder[a].successValue);
    }
    this.barChartLabels = this.barChartLabels;
    this.barChartData = [
      {
        data: this.barData,
        label: "Transaction Value",
      },
    ];
  }

  getUserDefaultLink() {
    this.sharedserv.getPaymentPages(this.userLocalDetails.clientId).subscribe(
      async (data) => {
        let isCustomLink = await this.checkCustomLink(data["data"]);
        this.customLink = isCustomLink
          ? `${environment.paymentPageLink}${this.checkCustomLink(
              data["data"]
            )}`
          : "";
      },
      (error) => {
        this.err.customclienterrors(
          "Failed",
          error.status,
          error.error.responseMessage
        );
      }
    );
  }

  //return the first link called default payment link
  checkCustomLink(val) {
    let a = val.find((e) => {
      return e.pageName == "Default Custom Link";
    });
    return a ? a.customLink : null;
  }

  copyToClipboard(value) {
    let listener = (e: ClipboardEvent) => {
      e.clipboardData.setData("text/plain", `${this.customLink}`);
      e.preventDefault();
    };
    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);
    this.notservice.Success("Payment Link Copied");
  }

  copyDirect(value) {
    let listener = (e: ClipboardEvent) => {
      e.clipboardData.setData("text/plain", `${value}`);
      e.preventDefault();
    };
    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);
    this.notservice.Success("Payment Link Copied");
  }
}

export class DataReq {
  minTransactionDate: string;
  maxTransactionDate: string;
  settlement: boolean;
  paymentChannel: boolean;
  transactionType: boolean;
  constructor() {
    this.paymentChannel = true;
    this.transactionType = true;
    this.settlement = true;
  }
}

export class DataRes {}
